const $ = sel => document.querySelector(sel);

const countdown = function (_config) {
  const root = $(_config.target);
  if (!root) return;

  // Read date
  const tarDate = root.getAttribute("data-date").split("-");
  const day = parseInt(tarDate[0], 10);
  const month = parseInt(tarDate[1], 10);
  const year = parseInt(tarDate[2], 10);

  // Read time
  const tarTime = root.getAttribute("data-time").split(":");
  const tarhour = parseInt(tarTime[0], 10) || 0;
  const tarmin = parseInt(tarTime[1], 10) || 0;

  // Loop settings
  const loopDays = parseInt(root.getAttribute("data-loop-days"), 10) || 1;
  const loopMs = loopDays * 24 * 60 * 60 * 1000;

  // Original target
  const initialTarget = new Date(year, month - 1, day, tarhour, tarmin, 0, 0).getTime();

  // Labels
  $(_config.target + " .day .word").textContent = _config.dayWord;
  $(_config.target + " .hour .word").textContent = _config.hourWord;
  $(_config.target + " .min .word").textContent = _config.minWord;
  $(_config.target + " .sec .word").textContent = _config.secWord;

  const updateTime = () => {
    const now = Date.now();

    // Work out the next valid target without ever showing expired values
    let countDownDate = initialTarget;

    if (now >= initialTarget) {
      const cyclesPassed = Math.floor((now - initialTarget) / loopMs) + 1;
      countDownDate = initialTarget + (cyclesPassed * loopMs);
    }

    let distance = countDownDate - now;

    // Round up slightly so it doesn't flash 00 too early
    const totalSeconds = Math.ceil(distance / 1000);

    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    $(_config.target + " .day .num").textContent = addZero(days);
    $(_config.target + " .hour .num").textContent = addZero(hours);
    $(_config.target + " .min .num").textContent = addZero(minutes);
    $(_config.target + " .sec .num").textContent = addZero(seconds);
  };

  updateTime();
  setInterval(updateTime, 250);
};

// leading zero
const addZero = x => (x < 10 ? "0" + x : String(x));